import { PropertyDefinitionOutputTypeEnum } from "src/clients/features-control";

export const EVENT_FILTER_PAGE_SIZE = 200;
export const EVENT_FILTER_MAX_POLL_TIME_MS = 2 * 60 * 1000; // 2 minutes
export const EVENT_FILTER_MAX_RETRIES = 3;
export const RATE_LIMIT_RETRY_DELAY_MS = 5000;
export const RATE_LIMIT_MESSAGE =
  "Rate limit exceeded. Please try again in a few moments.";

export const FILTERABLE_TYPES: PropertyDefinitionOutputTypeEnum[] = [
  PropertyDefinitionOutputTypeEnum.STRING,
  PropertyDefinitionOutputTypeEnum.BOOLEAN,
  PropertyDefinitionOutputTypeEnum.INTEGER,
  PropertyDefinitionOutputTypeEnum.NUMBER,
  PropertyDefinitionOutputTypeEnum.DATETIME,
  PropertyDefinitionOutputTypeEnum.DATE,
  PropertyDefinitionOutputTypeEnum.ENUM,
  PropertyDefinitionOutputTypeEnum.TAGS,
  PropertyDefinitionOutputTypeEnum.URL,
  PropertyDefinitionOutputTypeEnum.RELATION,
];
